
import { X } from 'lucide-react';
import { useState } from 'react';
import { EventType } from '@/lib/types';
import { eventTypeLabels } from '@/lib/eventLabels';
import { formatEventDate } from '@/lib/eventHelpers';
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

interface ActiveFiltersProps {
  search: string;
  location: string;
  selectedTypes: EventType[];
  hasCreditPoints: boolean;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  onTypeClick: (type: EventType) => void;
  onLocationClear: () => void;
  onCreditPointsClear: () => void;
  onDateRangeClear: (key: 'startDate' | 'endDate') => void;
  onResetAll: () => void;
}

const ActiveFilters = ({
  search,
  location,
  selectedTypes,
  hasCreditPoints,
  dateRange,
  onTypeClick,
  onLocationClear,
  onCreditPointsClear,
  onDateRangeClear,
  onResetAll
}: ActiveFiltersProps) => {
  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-medium text-base text-medihub-primary">Aktív szűrők</h3>
        <Button
          variant="outline"
          size="sm"
          onClick={onResetAll}
          className="text-medihub-primary"
        >
          Összes törlése
        </Button>
      </div>

      <div className="flex flex-wrap gap-2">
        {search && (
          <Badge variant="outline" className="flex gap-1 items-center bg-medihub-lightPurple/20">
            <span className="font-medium">Keresés:</span> {search}
            <X size={14} className="ml-1 cursor-pointer" onClick={onResetAll} />
          </Badge>
        )}

        {location && (
          <Badge variant="outline" className="flex gap-1 items-center bg-medihub-lightPurple/20">
            <span className="font-medium">Helyszín:</span> {location}
            <X size={14} className="ml-1 cursor-pointer" onClick={onLocationClear} />
          </Badge>
        )}

        {selectedTypes.map(type => (
          <Badge key={type} variant="outline" className="flex gap-1 items-center bg-medihub-lightPurple/20">
            <span className="font-medium">Típus:</span> {eventTypeLabels[type]}
            <X
              size={14}
              className="ml-1 cursor-pointer"
              onClick={() => onTypeClick(type)}
            />
          </Badge>
        ))}

        {hasCreditPoints && (
          <Badge variant="outline" className="flex gap-1 items-center bg-medihub-lightPurple/20">
            <span className="font-medium">Utóakkreditált esemény</span>
            <X size={14} className="ml-1 cursor-pointer" onClick={onCreditPointsClear} />
          </Badge>
        )}

        {dateRange.startDate && (
          <Badge variant="outline" className="flex gap-1 items-center bg-medihub-lightPurple/20">
            <span className="font-medium">Kezdődátum:</span> {formatEventDate(dateRange.startDate)}
            <X
              size={14}
              className="ml-1 cursor-pointer"
              onClick={() => onDateRangeClear('startDate')}
            />
          </Badge>
        )}

        {dateRange.endDate && (
          <Badge variant="outline" className="flex gap-1 items-center bg-medihub-lightPurple/20">
            <span className="font-medium">Végdátum:</span> {formatEventDate(dateRange.endDate)}
            <X
              size={14}
              className="ml-1 cursor-pointer"
              onClick={() => onDateRangeClear('endDate')}
            />
          </Badge>
        )}
      </div>
    </div>
  );
};

export default ActiveFilters;
